import {
    useState,
    useRef,
    useEffect
} from "react"
import PasswordInput from "../../../PasswordInput"
import SuccessPopup from "../../../SuccessPopUp"
import updateIcoverCredentials from "../../services/update-icover-credentials"
import TextInput from "../../../TextInput"
import ErrorPopUp from "../../../ErrorPopUp"

export default function UpdateIcoverCredentialsDialog({ open, onClose }) {
    const [showSuccess, setShowSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [dialogOpen, setDialogOpen] = useState(open)

    const usernameRef = useRef()
    const passwordRef = useRef()

    useEffect(() => {
        setDialogOpen(open)
        if (open) {
            usernameRef.current?.resetData()
            passwordRef.current?.resetData()
        }
    }, [open])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        const usernameData = usernameRef.current?.validateAndGetData()
        const passwordData = passwordRef.current?.validateAndGetData()

        if (!usernameData?.value) {
            setError("Username is required")
            return
        }

        if (!passwordData?.value) {
            setError("Password is required")
            return
        }

        if (!passwordData?.isValid) {
            setError(passwordData.errorMessage)
            return
        }

        try {
            setLoading(true)
            await updateIcoverCredentials({
                username: usernameData.value,
                password: passwordData.value,
            })
            setDialogOpen(false)
            setShowSuccess(true)
        } catch (err) {
            setError(err.response?.data?.message || "Failed to update password")
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            {dialogOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                    <div className="bg-white rounded-2xl shadow-lg w-11/12 md:w-1/3 p-6 relative">
                        <button
                            onClick={() => { setDialogOpen(false); onClose && onClose(); }}
                            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
                        >
                            ✕
                        </button>

                        <h2 className="text-xl font-semibold mb-4">Update Password</h2>

                        <form
                            className="space-y-4"
                            onSubmit={handleSubmit}
                            autoComplete="off"
                        >
                            {/* Dummy trap fields */}
                            <input
                                type="text"
                                name="fake-username"
                                autoComplete="username"
                                className="hidden"
                            />
                            <input
                                type="password"
                                name="fake-password"
                                autoComplete="new-password"
                                className="hidden"
                            />
                            <TextInput
                                ref={usernameRef}
                                title="Username"
                                placeholder="Enter username or email"
                                isMandatory={true}
                            />
                            <PasswordInput ref={passwordRef} isMandatory={true} />

                            {error && <p className="text-sm text-red-600">{error}</p>}

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg disabled:opacity-70"
                            >
                                {loading ? "Updating..." : "Update Password"}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {showSuccess && (
                <SuccessPopup
                    title="Update Password"
                    message="Your password has been successfully updated"
                    onClose={() => {
                        setShowSuccess(false)
                        usernameRef.current?.resetData()
                        passwordRef.current?.resetData()
                        onClose && onClose()
                    }}
                />
            )}

            {error && !dialogOpen && (
                <ErrorPopUp
                    title="Update Password Error"

                    message="Please try again later."
                    onClose={() => {
                        setError("")
                        onClose && onClose()
                    }}
                />
            )}
        </>
    )
}
